/**
 * 解析 AI 回應中的 ACTION_START / ACTION_END 區塊
 *
 * 對應後端 prompt_base.ACTION_FORMAT_INTRO 教 AI 的格式。
 */

import type { ParsedAction, ParsedAssistantMessage } from './types';

const BLOCK_RE = /ACTION_START\s*([\s\S]*?)\s*ACTION_END/g;

export function parseActions(content: string): ParsedAssistantMessage {
  const actions: ParsedAction[] = [];
  let match: RegExpExecArray | null;
  while ((match = BLOCK_RE.exec(content)) !== null) {
    const body = match[1];
    const obj: Record<string, string> = {};
    body.split('\n').forEach(line => {
      const idx = line.indexOf(':');
      if (idx <= 0) return;
      const k = line.slice(0, idx).trim();
      const v = line.slice(idx + 1).trim();
      if (k) obj[k] = v;
    });
    if (obj.type) {
      actions.push({
        raw: obj,
        edited: { ...obj },  // 預設拷貝；使用者可在卡片上編輯
        status: 'pending',
      });
    }
  }

  // 把 ACTION 區塊從顯示文字中移除（連同前後空行）
  const cleanText = content
    .replace(BLOCK_RE, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  return { text: cleanText, actions };
}
